export const createTranslationsHook =
  <T>(
    translations: { en: T; es?: T; pt?: T; fr?: T; de?: T },
    options?: { getLanguage?: () => string | undefined },
  ) =>
  () => {
    const preferredLanguage = options?.getLanguage?.();
    if (preferredLanguage) {
      const translation = Object.entries(translations).find(
        ([t]) =>
          preferredLanguage === t || preferredLanguage.startsWith(`${t}-`),
      )?.[1];
      if (translation) return translation as T;
    }

    const browserLanguages = navigator.languages;

    for (const lang of browserLanguages) {
      const translation = Object.entries(translations).find(
        ([t]) => lang === t || lang.startsWith(`${t}-`),
      )?.[1];

      if (translation) {
        return translation as T;
      }
    }

    return translations.en;
  };
